import lastYear2023H11 from '../../static/detail/lastYear/2023H1-1.jpeg'
import lastYear2023H12 from '../../static/detail/lastYear/2023H1-2.jpeg'
import lastYear2023H13 from '../../static/detail/lastYear/2023H1-3.jpeg'
import lastYear2023H14 from '../../static/detail/lastYear/2023H1-4.jpeg'
import lastYear2023H15 from '../../static/detail/lastYear/2023H1-5.jpeg'
import lastYear2023H16 from '../../static/detail/lastYear/2023H1-6.jpeg'
import lastYear2023H17 from '../../static/detail/lastYear/2023H1-7.jpeg'
import lastYear2023H18 from '../../static/detail/lastYear/2023H1-8.jpeg'
import lastYear2023H19 from '../../static/detail/lastYear/2023H1-9.jpeg'
import lastYear2023H110 from '../../static/detail/lastYear/2023H1-10.jpeg'
import lastYear2023H111 from '../../static/detail/lastYear/2023H1-11.jpeg'
import lastYear2023H112 from '../../static/detail/lastYear/2023H1-12.jpeg'
import lastYear2023H113 from '../../static/detail/lastYear/2023H1-13.jpeg'
import lastYear2023H114 from '../../static/detail/lastYear/2023H1-14.jpeg'
import lastYear2023H115 from '../../static/detail/lastYear/2023H1-15.jpeg'
import lastYear2023H116 from '../../static/detail/lastYear/2023H1-16.jpeg'
import lastYear2023H117 from '../../static/detail/lastYear/2023H1-17.jpeg'
import lastYear2023H118 from '../../static/detail/lastYear/2023H1-18.jpeg'
import lastYear2023H119 from '../../static/detail/lastYear/2023H1-19.jpeg'
import lastYear2023H120 from '../../static/detail/lastYear/2023H1-20.jpeg'

import scgypjjj_supply1 from '../../static/detail/hb/scgyp/jjj_supply1.png'
import scgypjjj_supply2 from '../../static/detail/hb/scgyp/jjj_supply2.png'
import scgypjjj_supply3 from '../../static/detail/hb/scgyp/jjj_supply3.png'
import scgypjjj_supply4 from '../../static/detail/hb/scgyp/jjj_supply4.png'
import scgypjjj_supply5 from '../../static/detail/hb/scgyp/jjj_supply5.png'
import scgypjjj_supply6 from '../../static/detail/hb/scgyp/jjj_supply6.png'

import scqhpjjj_abs1 from '../../static/detail/hb/scqhp/jjj_abs1.png'
import scqhpjjj_abs2 from '../../static/detail/hb/scqhp/jjj_abs2.png'
import scqhpjjj_abs3 from '../../static/detail/hb/scqhp/jjj_abs3.png'
import scqhpjjj_abs4 from '../../static/detail/hb/scqhp/jjj_abs4.png'
import scqhpjjj_abs5 from '../../static/detail/hb/scqhp/jjj_abs5.png'
import scqhpjjj_abs6 from '../../static/detail/hb/scqhp/jjj_abs6.png'
import scqhpjjj_abs7 from '../../static/detail/hb/scqhp/jjj_abs7.png'
import scqhpjjj_abs8 from '../../static/detail/hb/scqhp/jjj_abs8.png'
import scqhpjjj_abs9 from '../../static/detail/hb/scqhp/jjj_abs9.png'

import zjqspjjj_rent1 from '../../static/detail/hb/zjqsp/jjj_rent1.png'
import zjqspjjj_rent2 from '../../static/detail/hb/zjqsp/jjj_rent2.png'
import zjqspjjj_rent3 from '../../static/detail/hb/zjqsp/jjj_rent3.png'
import zjqspjjj_rent4 from '../../static/detail/hb/zjqsp/jjj_rent4.png'

import scgypyangtze_supply1 from '../../static/detail/hd/scgyp/yangtze_supply1.png'
import scgypyangtze_supply2 from '../../static/detail/hd/scgyp/yangtze_supply2.png'
import scgypyangtze_supply3 from '../../static/detail/hd/scgyp/yangtze_supply3.png'
import scgypyangtze_supply4 from '../../static/detail/hd/scgyp/yangtze_supply4.png'
import scgypyangtze_supply5 from '../../static/detail/hd/scgyp/yangtze_supply5.png'
import scgypyangtze_supply6 from '../../static/detail/hd/scgyp/yangtze_supply6.png'
import scgypyangtze_supply7 from '../../static/detail/hd/scgyp/yangtze_supply7.png'

import scqhpyangtze_abs1 from '../../static/detail/hd/scqhp/yangtze_abs1.png'
import scqhpyangtze_abs2 from '../../static/detail/hd/scqhp/yangtze_abs2.png'
import scqhpyangtze_abs3 from '../../static/detail/hd/scqhp/yangtze_abs3.png'
import scqhpyangtze_abs4 from '../../static/detail/hd/scqhp/yangtze_abs4.png'
import scqhpyangtze_abs5 from '../../static/detail/hd/scqhp/yangtze_abs5.png'
import scqhpyangtze_abs6 from '../../static/detail/hd/scqhp/yangtze_abs6.png'
import scqhpyangtze_abs7 from '../../static/detail/hd/scqhp/yangtze_abs7.png'

import zjzspyangtze_rent1 from '../../static/detail/hd/zjqsp/yangtze_rent1.png'
import zjzspyangtze_rent2 from '../../static/detail/hd/zjqsp/yangtze_rent2.png'
import zjzspyangtze_rent3 from '../../static/detail/hd/zjqsp/yangtze_rent3.png'
import zjzspyangtze_rent4 from '../../static/detail/hd/zjqsp/yangtze_rent4.png'
import zjzspyangtze_rent5 from '../../static/detail/hd/zjqsp/yangtze_rent5.png'
import zjzspyangtze_rent6 from '../../static/detail/hd/zjqsp/yangtze_rent6.png'

import scgyppearl_supply1 from '../../static/detail/hn/scgyp/pearl_supply1.png'
import scgyppearl_supply2 from '../../static/detail/hn/scgyp/pearl_supply2.png'
import scgyppearl_supply3 from '../../static/detail/hn/scgyp/pearl_supply3.png'
import scgyppearl_supply4 from '../../static/detail/hn/scgyp/pearl_supply4.png'
import scgyppearl_supply5 from '../../static/detail/hn/scgyp/pearl_supply5.png'
import scgyppearl_supply6 from '../../static/detail/hn/scgyp/pearl_supply6.png'

import scqhppearl_abs1 from '../../static/detail/hn/scqhp/pearl_abs1.png'
import scqhppearl_abs2 from '../../static/detail/hn/scqhp/pearl_abs2.png'
import scqhppearl_abs3 from '../../static/detail/hn/scqhp/pearl_abs3.png'
import scqhppearl_abs4 from '../../static/detail/hn/scqhp/pearl_abs4.png'
import scqhppearl_abs5 from '../../static/detail/hn/scqhp/pearl_abs5.png'

import zjqsppearl_rent1 from '../../static/detail/hn/zjqsp/pearl_rent1.png'
import zjqsppearl_rent2 from '../../static/detail/hn/zjqsp/pearl_rent2.png'
import zjqsppearl_rent3 from '../../static/detail/hn/zjqsp/pearl_rent3.png'
import zjqsppearl_rent4 from '../../static/detail/hn/zjqsp/pearl_rent4.png'

import scgypcentral_supply1 from '../../static/detail/hz/scgyp/central_supply1.png'
import scgypcentral_supply2 from '../../static/detail/hz/scgyp/central_supply2.png'
import scgypcentral_supply3 from '../../static/detail/hz/scgyp/central_supply3.png'
import scgypcentral_supply4 from '../../static/detail/hz/scgyp/central_supply4.png'
import scgypcentral_supply5 from '../../static/detail/hz/scgyp/central_supply5.png'

import scqhpcentral_abs1 from '../../static/detail/hz/scqhp/central_abs1.png'
import scqhpcentral_abs2 from '../../static/detail/hz/scqhp/central_abs2.png'
import scqhpcentral_abs3 from '../../static/detail/hz/scqhp/central_abs3.png'
import scqhpcentral_abs4 from '../../static/detail/hz/scqhp/central_abs4.png'
import scqhpcentral_abs5 from '../../static/detail/hz/scqhp/central_abs5.png'
import scqhpcentral_abs6 from '../../static/detail/hz/scqhp/central_abs6.png'
import scqhpcentral_abs7 from '../../static/detail/hz/scqhp/central_abs7.png'
import scqhpcentral_abs8 from '../../static/detail/hz/scqhp/central_abs8.png'

import zjqspcentral_rent1 from '../../static/detail/hz/zjqsp/central_rent1.png'
import zjqspcentral_rent2 from '../../static/detail/hz/zjqsp/central_rent2.png'
import zjqspcentral_rent3 from '../../static/detail/hz/zjqsp/central_rent3.png'
import zjqspcentral_rent4 from '../../static/detail/hz/zjqsp/central_rent4.png'
import zjqspcentral_rent5 from '../../static/detail/hz/zjqsp/central_rent5.png'

import reportPng from '../../static/report/report.png'
import selection1Png from '../../static/report/selection1.png'
import selection2Png from '../../static/report/selection2.png'
import selection3Png from '../../static/report/selection3.png'
import selection4Png from '../../static/report/selection4.png'

import scgyPng from '../../static/report/scgy.png'
import qschPng from '../../static/report/qsch.png'
import zjzsPng from '../../static/report/zjzs.png'


import csj2024H1_1 from '../../static/detail/csj2024H1/csj2024H1-1.png'
import csj2024H1_2 from '../../static/detail/csj2024H1/csj2024H1-2.png'
import csj2024H1_3 from '../../static/detail/csj2024H1/csj2024H1-3.png'
import csj2024H1_4 from '../../static/detail/csj2024H1/csj2024H1-4.png'
import csj2024H1_5 from '../../static/detail/csj2024H1/csj2024H1-5.png'
import csj2024H1_6 from '../../static/detail/csj2024H1/csj2024H1-6.png'
import csj2024H1_7 from '../../static/detail/csj2024H1/csj2024H1-7.png'
import csj2024H1_8 from '../../static/detail/csj2024H1/csj2024H1-8.png'
import csj2024H1_9 from '../../static/detail/csj2024H1/csj2024H1-9.png'
import csj2024H1_10 from '../../static/detail/csj2024H1/csj2024H1-10.png'
import csj2024H1_11 from '../../static/detail/csj2024H1/csj2024H1-11.png'
import csj2024H1_12 from '../../static/detail/csj2024H1/csj2024H1-12.png'
import csj2024H1_13 from '../../static/detail/csj2024H1/csj2024H1-13.png'
import csj2024H1_14 from '../../static/detail/csj2024H1/csj2024H1-14.png'
import csj2024H1_15 from '../../static/detail/csj2024H1/csj2024H1-15.png'
import csj2024H1_16 from '../../static/detail/csj2024H1/csj2024H1-16.png'
import csj2024H1_17 from '../../static/detail/csj2024H1/csj2024H1-17.png'
import csj2024H1_18 from '../../static/detail/csj2024H1/csj2024H1-18.png'
import csj2024H1_19 from '../../static/detail/csj2024H1/csj2024H1-19.png'
import csj2024H1_20 from '../../static/detail/csj2024H1/csj2024H1-20.png'
import csj2024H1_21 from '../../static/detail/csj2024H1/csj2024H1-21.png'
import csj2024H1_22 from '../../static/detail/csj2024H1/csj2024H1-22.png'
import csj2024H1_23 from '../../static/detail/csj2024H1/csj2024H1-23.png'
import csj2024H1_24 from '../../static/detail/csj2024H1/csj2024H1-24.png'
import csj2024H1_25 from '../../static/detail/csj2024H1/csj2024H1-25.png'
import csj2024H1_26 from '../../static/detail/csj2024H1/csj2024H1-26.png'

import zsj2024H1_1 from '../../static/detail/zsj2024H1/zsj2024H1-1.png'
import zsj2024H1_2 from '../../static/detail/zsj2024H1/zsj2024H1-2.png'
import zsj2024H1_3 from '../../static/detail/zsj2024H1/zsj2024H1-3.png'
import zsj2024H1_4 from '../../static/detail/zsj2024H1/zsj2024H1-4.png'
import zsj2024H1_5 from '../../static/detail/zsj2024H1/zsj2024H1-5.png'
import zsj2024H1_6 from '../../static/detail/zsj2024H1/zsj2024H1-6.png'
import zsj2024H1_7 from '../../static/detail/zsj2024H1/zsj2024H1-7.png'
import zsj2024H1_8 from '../../static/detail/zsj2024H1/zsj2024H1-8.png'
import zsj2024H1_9 from '../../static/detail/zsj2024H1/zsj2024H1-9.png'
import zsj2024H1_10 from '../../static/detail/zsj2024H1/zsj2024H1-10.png'
import zsj2024H1_11 from '../../static/detail/zsj2024H1/zsj2024H1-11.png'
import zsj2024H1_12 from '../../static/detail/zsj2024H1/zsj2024H1-12.png'
import zsj2024H1_13 from '../../static/detail/zsj2024H1/zsj2024H1-13.png'
import zsj2024H1_14 from '../../static/detail/zsj2024H1/zsj2024H1-14.png'
import zsj2024H1_15 from '../../static/detail/zsj2024H1/zsj2024H1-15.png'
import zsj2024H1_16 from '../../static/detail/zsj2024H1/zsj2024H1-16.png'
import zsj2024H1_17 from '../../static/detail/zsj2024H1/zsj2024H1-17.png'
import zsj2024H1_18 from '../../static/detail/zsj2024H1/zsj2024H1-18.png'
import zsj2024H1_19 from '../../static/detail/zsj2024H1/zsj2024H1-19.png'
import zsj2024H1_20 from '../../static/detail/zsj2024H1/zsj2024H1-20.png'
import zsj2024H1_21 from '../../static/detail/zsj2024H1/zsj2024H1-21.png'

// export let serverAPIPrefix = '/api'
// export let serverAPIPrefix = '//home-service.chinanestor.com'
// export let serverAPIPrefix = '//106.14.57.134:8130'

// 报告详情图片 维护
export let detailImage = {

  // 24年 长三角城市群
  'rmu45dtzl84fk': [
    csj2024H1_1,
    csj2024H1_2,
    csj2024H1_3,
    csj2024H1_4,
    csj2024H1_5,
    csj2024H1_6,
    csj2024H1_7,
    csj2024H1_8,
    csj2024H1_9,
    csj2024H1_10,
    csj2024H1_11,
    csj2024H1_12,
    csj2024H1_13,
    csj2024H1_14,
    csj2024H1_15,
    csj2024H1_16,
    csj2024H1_17,
    csj2024H1_18,
    csj2024H1_19,
    csj2024H1_20,
    csj2024H1_21,
    csj2024H1_22,
    csj2024H1_23,
    csj2024H1_24,
    csj2024H1_25,
    csj2024H1_26,
  ],
  // 24年 珠三角城市群
  '2mgv1a7tq8xgm': [
    zsj2024H1_1,
    zsj2024H1_2,
    zsj2024H1_3,
    zsj2024H1_4,
    zsj2024H1_5,
    zsj2024H1_6,
    zsj2024H1_7,
    zsj2024H1_8,
    zsj2024H1_9,
    zsj2024H1_10,
    zsj2024H1_11,
    zsj2024H1_12,
    zsj2024H1_13,
    zsj2024H1_14,
    zsj2024H1_15,
    zsj2024H1_16,
    zsj2024H1_17,
    zsj2024H1_18,
    zsj2024H1_19,
    zsj2024H1_20,
    zsj2024H1_21,
  ],
  //上一年
  'lastYear': [
    lastYear2023H11,
    lastYear2023H12,
    lastYear2023H13,
    lastYear2023H14,
    lastYear2023H15,
    lastYear2023H16,
    lastYear2023H17,
    lastYear2023H18,
    lastYear2023H19,
    lastYear2023H110,
    lastYear2023H111,
    lastYear2023H112,
    lastYear2023H113,
    lastYear2023H114,
    lastYear2023H115,
    lastYear2023H116,
    lastYear2023H117,
    lastYear2023H118,
    lastYear2023H119,
    lastYear2023H120,
  ],
  //长三角城市群
  'ifadn0d3nr': [
    scgypyangtze_supply1,
    scgypyangtze_supply2,
    scgypyangtze_supply3,
    scgypyangtze_supply4,
    scgypyangtze_supply5,
    scgypyangtze_supply6,
    scgypyangtze_supply7,
  ], // 市场供应
  'jlthw9d4in': [
    scqhpyangtze_abs1,
    scqhpyangtze_abs2,
    scqhpyangtze_abs3,
    scqhpyangtze_abs4,
    scqhpyangtze_abs5,
    scqhpyangtze_abs6,
    scqhpyangtze_abs7,
  ], // 市场去化
  '54ph2qv7t7': [
    zjzspyangtze_rent1,
    zjzspyangtze_rent2,
    zjzspyangtze_rent3,
    zjzspyangtze_rent4,
    zjzspyangtze_rent5,
    zjzspyangtze_rent6,
  ], // 租金走势
  //珠三角城市群
  'm66stley77': [
    scgyppearl_supply1,
    scgyppearl_supply2,
    scgyppearl_supply3,
    scgyppearl_supply4,
    scgyppearl_supply5,
    scgyppearl_supply6,
  ], // 市场供应
  'anep0egq2j': [
    scqhppearl_abs1,
    scqhppearl_abs2,
    scqhppearl_abs3,
    scqhppearl_abs4,
    scqhppearl_abs5,
  ], // 市场去化
  '4yusaz0mki': [zjqsppearl_rent1, zjqsppearl_rent2, zjqsppearl_rent3, zjqsppearl_rent4], // 租金走势
  //京津冀城市群
  '4liep9klmg': [
    scgypjjj_supply1,
    scgypjjj_supply2,
    scgypjjj_supply3,
    scgypjjj_supply4,
    scgypjjj_supply5,
    scgypjjj_supply6,
  ], // 市场供应
  '6tv4ms7dnh': [
    scqhpjjj_abs1,
    scqhpjjj_abs2,
    scqhpjjj_abs3,
    scqhpjjj_abs4,
    scqhpjjj_abs5,
    scqhpjjj_abs6,
    scqhpjjj_abs7,
    scqhpjjj_abs8,
    scqhpjjj_abs9,
  ], // 市场去化
  'rcujencjgr': [zjqspjjj_rent1, zjqspjjj_rent2, zjqspjjj_rent3, zjqspjjj_rent4], // 租金走势
  //华中城市群
  'vd6m8jfato': [
    scgypcentral_supply1,
    scgypcentral_supply2,
    scgypcentral_supply3,
    scgypcentral_supply4,
    scgypcentral_supply5,
  ], // 市场供应
  '1urpycpoat': [
    scqhpcentral_abs1,
    scqhpcentral_abs2,
    scqhpcentral_abs3,
    scqhpcentral_abs4,
    scqhpcentral_abs5,
    scqhpcentral_abs6,
    scqhpcentral_abs7,
    scqhpcentral_abs8,
  ], // 市场去化
  '2d09o1l4rv': [
    zjqspcentral_rent1,
    zjqspcentral_rent2,
    zjqspcentral_rent3,
    zjqspcentral_rent4,
    zjqspcentral_rent5,
  ], // 租金走势
}

// 大区
export let regionImage = {
  //上一年
  'lastYear': reportPng,
  //长三角城市群
  'csjlbxru7npw7': selection1Png,
  //珠三角城市群
  'zsjv4ih26fn16': selection2Png,
  //京津冀城市群
  'jjj1voa1rmjf8': selection3Png,
  //华中城市群
  'hzafdbyd3w9c': selection4Png,
}

export let regionDes = {
  //长三角城市群
  'csjlbxru7npw7':
    '长三角城市群描述长三角城市群描述长三角城市群描述长三角城市群描述长三角城市群描述长三角城市群描述',
  //珠三角城市群
  'zsjv4ih26fn16': '珠三角城市群描述珠三角城市群描述珠三角城市群描述珠三角城市群描述',
  //京津冀城市群
  'jjj1voa1rmjf8': '京津冀城市群描述京津冀城市群描述京津冀城市群描述',
  //华中城市群
  'hzafdbyd3w9c': '华中城市群群描述华中城市群群描述华中城市群群描述',
}

export let topicImage = [scgyPng, qschPng, zjzsPng]
// 话题描述 维护
export let topicDes = {
  //长三角城市群
  'ifadn0d3nr': '关键词：腹背受敌 更多关键词待你发现', // 市场供应
  'jlthw9d4in': '关键词：去化王 更多关键词待你发现', // 市场去化
  '54ph2qv7t7': '关键词：租户大迁徙 更多关键词待你发现', // 租金走势
  //珠三角城市群
  'm66stley77': '关键词：大湾区总量 更多关键词待你发现', // 市场供应
  'anep0egq2j': '关键词：跨境电商 更多关键词待你发现', // 市场去化
  '4yusaz0mki': '关键词：省钱秘籍 更多关键词待你发现', // 租金走势
  //京津冀城市群
  '4liep9klmg': '关键词：千万俱乐部 更多关键词待你发现', // 市场供应
  '6tv4ms7dnh': '关键词：图书 更多关键词待你发现', // 市场去化
  'rcujencjgr': '关键词：腰斩 更多关键词待你发现', // 租金走势
  //华中城市群
  'vd6m8jfato': '关键词：东西湖 更多关键词待你发现', // 市场供应
  '1urpycpoat': '关键词：吃货经济 更多关键词待你发现', // 市场去化
  '2d09o1l4rv': '关键词：多米诺骨牌 更多关键词待你发现', // 租金走势
}

